import React from 'react';
import { ProgressBar } from 'react-bootstrap-5';

type Props = {
  progress: number;
}

export default function LoadingBar({ progress }: Props) {
  return (
    <div className="bg-light p-2 rounded border">
      <div>
        <span className="fw-bolder text-base text-primary" >{progress}%</span>
      </div>
      <div>
        <ProgressBar className="border" now={progress} />
      </div>
    </div>
  );
}
